
import Drawer from '@mui/material/Drawer'
import { useStyles } from './styles'
import { IconButton, Typography, Box, Button, Grid } from '@mui/material'

import { useTranslation } from 'react-i18next'
import { RightActivityForm } from '../rigthActivityForm'
import { LeftActivityForm } from '../leftActivityForm'
import { PropsActivityForm } from './types'
import { useEffect, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import { DestinationType } from '../../enums/destinationType'
import { useCreatEdit } from '../../hooks/useForm'
import SimpleModal from '../../../../../../../../../../components/modal/simpleModal'


export const ActivityForm = (props: PropsActivityForm) => {

    const styles = useStyles()
    const { t } = useTranslation()
    const { onChangeCrud, dataActivity, handleDataActivity, handleChangeCrud, dataDestination, handleDataDestination, onChangeDestination } = useCreatEdit()
    const [defaultValues, setDefaultValues] = useState<{ from?: Dayjs; to?: Dayjs; }>({ from: dayjs().add(1, 'minute'), to: null });
    const [idToEdit, setIdToEdit] = useState(0)
    const [isToBiggerThanFrom, setIsToBiggerThanFrom] = useState(dayjs(defaultValues.to).date() > dayjs(defaultValues.from).date())
    const [openModal, setOpenModal] = useState<{
        open: boolean;
        title?: string;
        description?: string;
        confirm?: () => void;
    }>({ open: false })
    const [selectedPoint, setSelectedPoint] = useState<{ lat: number; lng: number } | null>(null);

    const getDate = (date: Dayjs, name: 'to' | 'from') => {
        setDefaultValues(prev => ({ ...prev, [name]: date }))
        handleChangeCrud({ name, date })
    }

    const toggleDrawer = () => {
        props.setOpen(false)
        handleDataActivity()
        handleChangeCrud({ name: 'from', date: dayjs().add(1, 'minute') })
        setDefaultValues({ from: dayjs().add(1, 'minute'), to: null })
        props.setDestinationFinal(undefined)
        setIdToEdit(0)
    }

    const handleSubtmit = () => {
        if (props.allUsers) {
            //preguntar con el modal
            setOpenModal((prev) => ({
                ...prev,
                open: true,
                title: t('loogbook.modal.assignAllUsersTtitle'),
                description: t('loogbook.modal.assignAllUsersDescription'),
                confirm: () => {
                    props.assignActivities()
                    closeModal()
                    props.setOpen(false)
                }
            }));
        } else {
            //asignar actividadesd
            props.assignActivities()
            props.setOpen(false)
        }

    }

    const closeModal = () => {
        setOpenModal((prev) => ({ ...prev, open: false }));
    };

    useEffect(() => {
        handleChangeCrud({ name: 'from', date: dayjs().add(1, 'minute') })
    }, [props.open])

    useEffect(() => {
        if (dataActivity?.title == '') {
            const { title, ...rest } = dataActivity;
            handleDataActivity(rest);
        }
    }, [dataActivity?.title])

    useEffect(() => {

        if (!dataActivity?.typeOfActivity && dataActivity?.open) {
            const { open, ...rest } = dataActivity;
            handleDataActivity(rest);
        }

        if (dataActivity?.typeOfActivity?.openField) {
            props.setInputActivity((prevInput) => ({
                ...prevInput,
                open: props.typeActivityOpen,
            }));
        } else {
            props.setInputActivity((prevInput) => {
                const { open, ...rest } = prevInput;
                return rest;
            });
        }
    }, [dataActivity?.typeOfActivity]);

    return (

        <Drawer
            PaperProps={{
                sx: { width: '50%', padding: '20px', minWidth: '670px' },
            }}
            anchor={'right'}
            open={props.open}
        /* onClose={toggleDrawer} */
        >

            <Grid container sx={styles.grid} spacing={1}>
                <Grid item xs={5} sx={styles.gridLeft} className='left'>
                    <LeftActivityForm
                        inputActivity={props.inputActivity}
                        inputActivityCheck={props.inputActivityCheck}
                        defaultValues={defaultValues}
                        getDate={getDate}
                        isToBiggerThanFrom={isToBiggerThanFrom}
                        setIsToBiggerThanFrom={setIsToBiggerThanFrom}
                        destination={props.destination}
                        setDestination={props.setDestination}
                        dataActivity={dataActivity}
                        onChangeCrud={onChangeCrud}
                        handleActivities={props.handleActivities}
                        handleDataActivity={handleDataActivity}
                        handleChangeCrud={handleChangeCrud}
                        setDefaultValues={setDefaultValues}
                        idToEdit={idToEdit}
                        setIdToEdit={setIdToEdit}
                        editActivity={props.editActivity}
                        inputFilterUnity={props.inputFilterUnity}
                        tableUnits={props.table}
                        filterUnity={props.filterUnity}
                        loading={props.loading}
                        totalPages={props.totalPages}
                        destinationFinal={props.destinationFinal}
                        setDestinationFinal={props.setDestinationFinal}
                        setUnityToDestination={props.setUnityToDestination}
                        inputDestination={props.inputDestination}
                        dataDestination={dataDestination}
                        handleDataDestination={handleDataDestination}
                        onChangeDestination={onChangeDestination}
                        selectedPoint={selectedPoint}
                        setSelectedPoint={setSelectedPoint}
                        handleRowClickUnity={props.handleRowClickUnity}
                        companies={props.companies}
                        editActivityDestination={props.editActivityDestination}
                        localRegister={props.localRegister}
                        setLocalRegister={props.setLocalRegister}
                        destinatioCreated={props.destinatioCreated}
                    />
                    <Typography variant="body1" sx={styles.cleanFilters} onClick={toggleDrawer}>
                        {t('general.cancel')}
                    </Typography>
                </Grid>
                <Grid item xs={7} sx={styles.gridLeft}>
                    <RightActivityForm
                        activities={props.activities}
                        deleteActivity={props.deleteActivity}
                        handleDataActivity={handleDataActivity}
                        setDefaultValues={setDefaultValues}
                        setIdToEdit={setIdToEdit}
                        handleChangeCrud={handleChangeCrud}
                        setDestinationFinal={props.setDestinationFinal}
                        setSelectedPoint={setSelectedPoint}
                    />
                    <Box sx={styles.actions}>
                        <Button onClick={() => { handleSubtmit() }} variant="contained">
                            {t('general.save')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            {/* <Box sx={styles.actions}> */}

            {/* <Typography variant="body1" sx={styles.cleanFilters} onClick={toggleDrawer}>
                    {t('general.cancel')}
                </Typography> */}

            {/* <Button onClick={() => { handleSubtmit() } } variant="contained">
                    {t('general.save')}
                </Button> */}
            {/* </Box> */}

            <SimpleModal
                open={openModal.open}
                close={() => {
                    closeModal()
                }}
                title={openModal?.title}
                description={openModal?.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                back={() => {
                    closeModal()
                }}
                next={() => {
                    if (openModal?.confirm) {
                        openModal.confirm()
                    }
                }}
            />
        </Drawer>
    )
}